import { Modal } from "@mui/material";
import * as React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Game_Global_Vars } from "../utils";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";


export default function ProvablyFairModel({
  open,
  setOpen,
  handleUserGamesCreateApi,
}: {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleUserGamesCreateApi: React.Dispatch<React.SetStateAction<any>>;
}) {
  const [hash, setHash] = React.useState<string>("");
  const handleClose = () => setOpen(false);
  React.useEffect(() => {
    setHash(Game_Global_Vars.hash);
  }, []);
  const handleFatchHash = async () => {
    try {
      const result: any = await handleUserGamesCreateApi(null);

      console.log(result);
      if (result?.status) {
        setHash(Game_Global_Vars.hash);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="w-full h-full max-h-screen min-h-screen bg-[#212121]">
        <button
          onClick={handleClose}
          className="w-10 h-10 fixed top-10 right-10 cursor-pointer bg-[#333] rounded-full text-white"
        >
          <CloseIcon />
        </button>

        <div className="flex flex-col gap-4 justify-center items-center font-salsa text-white h-full min-h-screen">
          <h1 className="text-2xl">Provably Fair</h1>
          <div className="grid grid-cols-1 gap-y-3 gap-x-4  justify-center items-center w-fit">
            <ChipItem

              data={{
                title: "CLIENT SEED",
                value: Game_Global_Vars.client_seed,
              }}
            />
            <ChipItem

              data={{
                title: "SERVER HASH",
                value: hash || Game_Global_Vars.hash,
              }}
            />

            <button
              onClick={handleFatchHash}
              className="w-full px-4 bg-[#FFAE01] rounded-md text-black text-[24px] transition-all ease-in-out hover:bg-[#FFAE01]/80"
            >
              Genrate
            </button>
            <button
              onClick={handleClose}
              className="w-full px-4 bg-[#787882] rounded-md text-[24px] transition-all ease-in-out hover:bg-[#787882]/80"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
const ChipItem = ({

  data: { title, value },
}: {

  data: { title: string; value: string };
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!/^\d+$/.test(e.target.value)) return;
    console.log(e.target.value, title);
  };
  return (
    <div className="flex flex-col gap-[1px] rounded-lg px-2 w-full py-[2px] border-2 border-white text-center bg-black">
      <h1>{title}</h1>
      <input
        onChange={handleChange}
        type="string"
        value={value}
        className="text-lg bg-transparent w-full text-center focus-within:outline-none"
      />
      {title === "SERVER HASH" ? (
        <div className="relative">
          <ContentCopyIcon
            onClick={() => {
              window.navigator.clipboard.writeText(value);
            }}
            style={{
              top: "-17px",
              right: "-25px",
              height: "30px",
              width: "30px",
              cursor:"pointer"
            }}
            className="absolute p-2 bg-[#FFAE01] rounded-full text-black text-[24px] transition-all ease-in-out hover:bg-[#FFAE01]/80"
          />
        </div>
      ) : null}
    </div>
  );
};
